import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ApiService } from '../../services/api.service';
 


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _apiService: ApiService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          //this.loginService.logout();
          // tslint:disable-next-line: deprecation
          //location.reload(true);
        }else if (err.error && err.error.status) {
          this._apiService.error(err.error.message);
        }
        else {
          this._apiService.error(err.statusText);
        }
        return throwError(err);
      }))
  }
}
